module.exports = __webpack_public_path__ + "img/69eebf5.jpg";